import { Cascader, CascaderAutoProps } from "antd";
import classNames from "classnames";

import {
  IndustryCodeCategory,
  useGetApiV1GenericIndustryCodeHierarchyQuery,
} from "../../store/coreApi";
import styles from "./IndustryCodesInput.module.less";

const IndustryCodesInput = ({
  className,
  ...props
}: CascaderAutoProps<IndustryCodeCategory, "id">) => {
  const { data: industryCodeHierarchy } =
    useGetApiV1GenericIndustryCodeHierarchyQuery();

  const filter = (inputValue: string, path: IndustryCodeCategory[]) =>
    path.some(
      (option) =>
        option.descriptionLong.toLowerCase().indexOf(inputValue.toLowerCase()) >
        -1
    );

  return (
    <Cascader<IndustryCodeCategory, "id">
      showSearch={{ filter }}
      options={industryCodeHierarchy?.children ?? []}
      fieldNames={{
        label: "descriptionLong",
        value: "id",
      }}
      multiple={false}
      className={classNames(className, styles.normal)}
      {...props}
    />
  );
};

export default IndustryCodesInput;
